var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37476 14.625H4.49976V22.5C4.49976 23.7409 5.50889 24.75 6.74976 24.75H20.2498C21.4906 24.75 22.4998 23.7409 22.4998 22.5V14.625H23.6248C23.8472 14.625 24.0647 14.559 24.2496 14.4353C24.4346 14.3117 24.5788 14.136 24.6639 13.9305C24.749 13.725 24.7713 13.4988 24.7279 13.2806C24.6845 13.0624 24.5774 12.862 24.4201 12.7046L14.2951 2.57964C14.1907 2.47507 14.0668 2.39212 13.9303 2.33552C13.7938 2.27892 13.6475 2.24979 13.4998 2.24979C13.352 2.24979 13.2057 2.27892 13.0692 2.33552C12.9328 2.39212 12.8088 2.47507 12.7044 2.57964L2.57939 12.7046C2.4221 12.862 2.31499 13.0624 2.2716 13.2806C2.22822 13.4988 2.25049 13.725 2.33562 13.9305C2.42075 14.136 2.56491 14.3117 2.74987 14.4353C2.93483 14.559 3.15229 14.625 3.37476 14.625ZM13.4998 4.96576L20.2498 11.7158V16.875L20.2509 22.5H6.74976V11.7169L13.4998 4.96576Z",
    fill: "#3E3F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.125C15.9818 19.125 18 17.1068 18 14.625C18 12.1432 15.9818 10.125 13.5 10.125C11.0182 10.125 9 12.1432 9 14.625C9 17.1068 11.0182 19.125 13.5 19.125ZM13.5 12.375C14.7409 12.375 15.75 13.3841 15.75 14.625C15.75 15.8659 14.7409 16.875 13.5 16.875C12.2591 16.875 11.25 15.8659 11.25 14.625C11.25 13.3841 12.2591 12.375 13.5 12.375Z",
    fill: "#3E3F3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b33492c698f5bc9b1cb1c4fe7e800524.svg";
export { ForwardRef as ReactComponent };